import { getGroupTypeForFilter } from '../../../../../util/groups.util'
import { actions as GWS_ACTIONS } from '../../integrations/gws/actions'
import { groupTypes } from '../../integrations/m365/groupTypes'

const M365_GROUP_TYPES = new Set(Object.values(groupTypes))

export const getGroupEntryId = (group) => {
  if (group == null) {
    return undefined
  }
  return group.id ?? group.groupId ?? group.GroupId
}

export const getGroupEntryName = (group) => {
  if (group == null) {
    return ''
  }
  return group.name ?? group.displayName ?? group.Name ?? ''
}

export const getAssignableGroups = (allEmployeesGroups = [], action) => {
  const groups = (allEmployeesGroups || []).filter((group) => getGroupEntryId(group) != null)

  if (action === GWS_ACTIONS.GWS_MANAGE_GROUPS) {
    return groups.filter((group) => !M365_GROUP_TYPES.has(getGroupTypeForFilter(group)))
  }

  return groups.filter((group) => getGroupTypeForFilter(group) === groupTypes.M365Group)
}
